import React, { useContext } from 'react';
import styled from 'styled-components';
import { Modal as BaseModal, Header1, Header2, Button } from '@ubeya/shared-web/components';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import { ReactComponent as UbeyaIcon } from '@ubeya/shared-web/assets/ubeya_logo_black.svg';
import useBillingMethods from '@ubeya/shared/hooks/generic/useBillingMethods';
import useUser from '@ubeya/shared/hooks/auth/useUser';
import { openHelpCenter } from '@ubeya/shared/atoms/shared';
import { useRecoilState } from 'recoil';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import CreditCard from 'billing/components/CreditCard';

const Modal = styled(BaseModal)`
  border-radius: 0;

  .content {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
`;

const CreditCardWrapper = styled.div`
  margin: 20px 0;
`;

const Title = styled(Header1)`
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  margin: 40px 0;
  line-height: 50rem;
`;

const SubTitle = styled(Header2)`
  padding-top: 10px;
  text-align: center;
  margin-bottom: 40px;
  line-height: 30rem;
`;

const ButtonsContainer = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const LogoutButton = styled.div`
  position: absolute;
  right: 20px;
  color: ${({ theme }) => theme.colors.primary};

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const ContainerIcon = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10%;

  > svg {
    height: 50%;
    width: 100%;
  }
`;

const ButtonsText = styled(SubTitle)`
  margin-bottom: 10px;
`;

const BasePaymentModal = ({ onClose, title, subTitleContent, footerText }) => {
  const { account } = useAccount();
  const { addBillingMethod } = useBillingMethods();
  const { isUbeyaAdmin, logout } = useUser();
  const [, setIsOpenHelpCenter] = useRecoilState(openHelpCenter);
  const { t } = useContext(ConfigContext);

  const accountBilling = account?.settings?.billing || {};

  const onAddingBillingMethod = async (values) => {
    await addBillingMethod(values);
    onClose();
  };

  return (
    <Modal
      size="fullScreen"
      showConfirmButton={false}
      allowEmptyTitle={!!isUbeyaAdmin}
      onClose={isUbeyaAdmin ? onClose : undefined}>
      <ContainerIcon>
        <UbeyaIcon />
      </ContainerIcon>

      <Title>{title}</Title>

      <SubTitle>{subTitleContent}</SubTitle>

      <CreditCardWrapper>
        <CreditCard
          addBillingMethod={onAddingBillingMethod}
          method={accountBilling?.billingMethods?.find(({ payload }) => payload?.isActive === true)}
        />
      </CreditCardWrapper>

      <ButtonsText>{footerText}</ButtonsText>
      <ButtonsContainer>
        <Button
          secondary
          narrow
          onClick={() => {
            setIsOpenHelpCenter(true);
          }}>
          {t('contactUs')}
        </Button>

        <LogoutButton onClick={() => logout('admin')}>{t('logout')}</LogoutButton>
      </ButtonsContainer>
    </Modal>
  );
};

export default BasePaymentModal;
